<h1 mat-dialog-title>File Upload</h1>
<div mat-dialog-content>
  <div class="dropzone" appDragAndDrop (fileDropped)="handleDrop($event)">
    <input
      type="file"
      #fileDropRef
      id="fileDropRef"
      multiple
      (change)="handleChange($event)"
    />
    <h3>Drag and Drop file here</h3>
    <label for="fileDropRef">Browse for file</label>
  </div>

  <div class="files-list">
    <div class="single-file" *ngFor="let file of files; let i = index">
      <img src="assets/document.svg" width="45px" alt="file" />

      <div class="info">
        <h4 class="name">
          {{ file?.name }}
        </h4>
        <p class="size">
          {{ formatBytes(file.size) }}
        </p>
      </div>
      <button mat-icon-button (click)="deleteFile(i)" class="delete">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="uploadFiles()">
    Upload
  </button>
</div>
